import { ResourceResponse } from 'generated/index';
import { mutations } from 'RestAPIs/rapini';

export const useSaveResource = (props: { onSuccess: () => void }) => {
  const { mutate: createResource, isLoading: isCreateLoading } =
    mutations.useCreateResource();
  const { mutate: updateResource, isLoading: isUpdateLoading } =
    mutations.useUpdateResource();

  const mutate = (data: ResourceResponse) => {
    if (!data.id) {
      createResource(
        {
          name: data.name!,
          description: data.description!,
          code: data.code!,
          checkOverlap: data.checkOverlap ?? false
        },
        {
          onSuccess: props.onSuccess
        }
      );
    } else {
      updateResource(
        {
          id: data.id!,
          name: data.name!,
          description: data.description!,
          code: data.code!,
          checkOverlap: data.checkOverlap ?? false
        },
        {
          onSuccess: props.onSuccess
        }
      );
    }
  };

  return {
    mutate,
    isLoading: isCreateLoading || isUpdateLoading
  };
};
